/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 計算モード
 * @export
 * @interface CalculationMode
 */
export interface CalculationMode {
    /**
     * 計算モード
     * @type {string}
     * @memberof CalculationMode
     */
    mode?: string;
    /**
     * 目標苛性生産量
     * @type {number}
     * @memberof CalculationMode
     */
    targetNaoh?: number;
    /**
     * 目標塩素生産量
     * @type {number}
     * @memberof CalculationMode
     */
    targetCl2?: number;
    /**
     * 塩素生産率
     * @type {number}
     * @memberof CalculationMode
     */
    cl2Efficiency?: number;
}

/**
 * Check if a given object implements the CalculationMode interface.
 */
export function instanceOfCalculationMode(value: object): value is CalculationMode {
    return true;
}

export function CalculationModeFromJSON(json: any): CalculationMode {
    return CalculationModeFromJSONTyped(json, false);
}

export function CalculationModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationMode {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': json['mode'] == null ? undefined : json['mode'],
        'targetNaoh': json['targetNaoh'] == null ? undefined : json['targetNaoh'],
        'targetCl2': json['targetCl2'] == null ? undefined : json['targetCl2'],
        'cl2Efficiency': json['cl2Efficiency'] == null ? undefined : json['cl2Efficiency'],
    };
}

export function CalculationModeToJSON(value?: CalculationMode | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'mode': value['mode'],
        'targetNaoh': value['targetNaoh'],
        'targetCl2': value['targetCl2'],
        'cl2Efficiency': value['cl2Efficiency'],
    };
}

